<template>
    <div class="row">
        <div class="col-md-12 mb-3">
            <div class="contacts_header d-md-flex align-items-center">
                <div class="d-flex align-items-center mb-2 mb-md-0">
                    <h5 class="mr-2 my-0 font-weight-bold">Contacts</h5>
                    <span class="badge badge-light badge-sm" v-text="`(${contacts.length})`"></span>
                </div>
                <div class="d-flex ml-auto">
                    <import-contact @contact-uploaded="getContacts()"></import-contact>
                    <div>
                        <button class="btn btn-moneypool-sm" data-toggle="modal" data-target="#newContactModal">Add Contact</button>
                    </div>
                        
                </div>
            </div>
        </div>
        
        <div class="col-md-12 mt-3" v-if="contacts.length > 0">
            <div class="card border-0 ">
                <div class="card-body p-0">
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <!-- <thead>
                                <tr>
                                <th scope="col">#</th>
                                <th scope="col">First</th>
                                <th scope="col">Last</th>
                                <th scope="col">Handle</th>
                                </tr>
                            </thead> -->
                            <tbody>
                                <tr class="d-flex" v-for="(contact, index) in contacts" :key="index"  
                                    @mouseover="showEditButton(index)" @mouseout="hideEditButton(index)">
                                    <th scope="row">{{ index + 1}}.</th>
                                    <td style="width: 300px;">{{ contact.name }}</td>
                                    <td style="width: 300px;">{{ contact.email }}</td>
                                    <td style="width: 250px;">{{ contact.phone }}</td>
                                    <td style="width: 200px;" class="text-muted td-hoverable d-flex justify-content-center" >
                                        <div class="" v-show="td_visible" :ref="`table-action-btns-${index}`">
                                            <div class="d-flex">
                                                <a data-toggle="modal" :data-target="`#updateContactModal${index}`">
                                                    <span class="fa fa-pen fa-sm mr-4" ></span>
                                                </a>
                                                <a @click="deleteContact(contact, index)">
                                                    <span class="fa fa-trash fa-sm"></span>
                                                </a>

                                            </div>

                                        </div>
                                    </td>

                                    <!-- Modal -->
                                    <div class="modal fade" :id="`updateContactModal${index}`" ref="updateModal" tabindex="-1" role="dialog" aria-labelledby="newContactModalLabel" aria-hidden="true">
                                        <div class="modal-dialog" role="document">
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <h6 class="modal-title" id="newContactModalLabel">Update Contact</h6>
                                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div class="modal-body">
                                                    <form @submit.prevent="updateContact(contact)">
                                                        <div class="form-group">
                                                            <label for="name" class="mb-1">
                                                                <small>Name</small>
                                                            </label>
                                                            <input type="text" v-model="contact.name" class="form-control">
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="name" class="mb-1"><small>Email</small></label>
                                                            <input type="email" v-model="contact.email" class="form-control">
                                                        </div>
                                                        <div class="form-group mb-5">
                                                            <label for="name" class="mb-1"><small>Phone Number</small></label>
                                                            <vue-tel-input @country-changed="updateCountry($event, contact)" v-model="contact.phone" v-bind="bindProps"></vue-tel-input>
                                                        </div>
                                                        <div class="modal-footer">
                                                            <button type="submit" class="btn btn-custom-sm">Save Changes</button>
                                                            <button type="button" class="btn btn-outline-dark btn-sm" data-dismiss="modal">Close</button>
                                                        </div>
                                                        
                                                    </form>
                                                    
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>

        </div>

        <div class="col-md-12" v-if="loading">
            <p class="text-center">loading...</p>
        </div>

        <div class="col-md-12" v-if="! loading && contacts.length < 1">
            <div class="card border-0">
                <div class="card-body">
                    <div class="d-flex flex-column justify-content-center align-items-center" style="height:100vh">
                        <p class=""><span class="fa fa-folder"></span> No Contacts </p>

                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="newContactModal" tabindex="-1" role="dialog" aria-labelledby="newContactModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="newContactModalLabel">Create Contact</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="saveContact()">
                            <div class="form-group">
                                <label for="name" class="mb-1">
                                    <small>Name</small>
                                </label>
                                <input type="text" v-model="form.name" class="form-control">
                            </div>
                            <div class="form-group">
                                <label for="name" class="mb-1"><small>Email</small></label>
                                <input type="email" v-model="form.email" class="form-control">
                            </div>
                            <div class="form-group mb-5">
                                <label for="name" class="mb-1"><small>Phone Number</small></label>
                                <vue-tel-input @country-changed="getCountry($event)" v-model="form.phone" v-bind="bindProps"></vue-tel-input>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-outline-dark btn-sm" data-dismiss="modal">Close</button>
                                <button type="submit" class="btn btn-moneypool-sm">Save Contact</button>
                            </div>
                            
                        </form>
                        
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImportContact from '@/components/ImportContact'

export default {
    components: {
        ImportContact
    },
    data () {
        return {
            td_visible: false,
            contacts: [],
            form: {
                phone: '',
                name: '',
                email: '',
                country: '',
                dialCode: ''
            },
            bindProps: {
                defaultCountry: "NG",
                disabledFetchingCountry: false,
                disabled: false,
                disabledFormatting: false,
                placeholder: "Enter a phone number",
                required: true,
                enabledCountryCode: false,
                enabledFlags: true,
                preferredCountries: ["AU", "BR"],
                onlyCountries: [],
                ignoredCountries: [],
                autocomplete: "off",
                name: "telephone",
                maxLen: 25,
                wrapperClasses: "",
                inputClasses: "",
                dropdownOptions: {
                    disabledDialCode: true
                },
                inputOptions: {
                    showDialCode: false
                }
            },
            loading: false
        }
    },

    created() {
        this.getContacts();
    },

    methods: {
        getCountry($event) {
            const { iso2, dialCode } = $event;

            this.form.dialCode = dialCode;
            this.form.country = iso2;
        },
        updateCountry($event, contact) {
            const { dialCode, iso2 } = $event;

            contact.country = iso2;
        },

        async saveContact() {

            let data = {...this.form}
            data.phone = `+${data.dialCode}${data.phone}`

            try {
                const contact = await axios.post('/pool/contacts/add', data);

                if (contact.status == 200) {
                    const { message } = contact.data;

                    this.contacts.push(message)
                    
                    this.form.phone = this.form.name = this.form.email = this.form.country = this.form.dialCode = '';

                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Success',
                        text: 'Your contact has been added successfully'
                    });
                }
            } catch (error) {
                // console.log(error.response);
            } 
        },
        async getContacts() {
            
            this.loading = true;

            try {
                const contacts = await axios.post('/pool/contacts');
                const { status, message } = contacts.data;

                this.loading = false;

                if (contacts.status =  200) {

                    if (message.length < 1) {
                        this.contacts = [];
                    } else {
                        this.contacts = message
                    }
                }
            } catch (error) {
                this.loading = false;
                // console.log(error.response);
            }
        },

        async updateContact(contact) {
            const data = {...contact, contact_id: contact.id };

            try {
                const contact = await axios.post('/pool/contacts/update', data);

                if (contact.status == 200) {
                    $(this.$refs.updateModal).modal('hide');

                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Success',
                        text: 'Contact updated succesfully'
                    }) 
                }
            } catch (error) {
                // console.log(error.response);
            }
        },
        
        async deleteContact(contact, index) {

            try {
                const response = await axios.post('/pool/contacts/remove', { contact_id: contact.id });

                if (response.status == 200) {

                    this.contacts.splice(index, 1)
                }
            } catch (error) {
                // console.log(error.response);
            }
        },
        showEditButton(index) {
            $(this.$refs['table-action-btns-'+ index]).show();
        },
        hideEditButton(index) {
            $(this.$refs['table-action-btns-'+ index]).hide();
        }
    }
}
</script>

<style>

</style>